import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { UserService } from 'src/app/services/userService/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-payment-dialog',
  templateUrl: './payment-dialog.component.html',
  styleUrls: ['./payment-dialog.component.less']
})
export class PaymentDialogComponent implements OnInit {
  currentStep = 0;
  selectedProduct;
  paymentMethods;
  selectedPaymentMethod;
  paymentUrl;
  orderId;
  polling;
  env = environment;
  swipConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 8.5,
    spaceBetween: 15,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: true,
    pagination: false,
    slidesOffsetBefore: 64,
    slidesOffsetAfter: 15,
    watchOverflow: true,
    breakpoints: {
      0: {
        slidesPerView: 1.5
      },
      768: {
        slidesPerView: 2.5
      },
      992: {
        slidesPerView: 4.5
      },
      1920: {
        slidesPerView: 5.5
      }
    }
  };
  constructor(public dialogRef: MatDialogRef<PaymentDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private translate: TranslateService, private userService: UserService) { }

  ngOnInit(): void {
    if (this.data && this.data.products?.length > 1) {
      this.currentStep = 0;
    } else {
      this.currentStep = 0;
      if (this.userService.getSubscriber()?.address) {
        this.currentStep = 1;
        this.selectProduct(this.data.products[0]);
      } else {
        this.currentStep = 0.1;
      }
    }
  }

  // Select a product
  selectProduct(product) {
    // Select a product and prepare the proper message
    this.selectedProduct = product;
    this.translate.get("payment_method_product_msg", {
      name: this.selectedProduct.title,
      price: this.env.priceUnit + this.selectedProduct.price
    }).subscribe((text: string) => {
      this.selectedProduct.newTitle = text;
    });

    // Get payment methods
    this.currentStep = 1;
    this.paymentMethods = this.data.productsService.getPaymentMethods();
    this.selectedPaymentMethod = this.paymentMethods[0];
  }

  // Event trigger when the user saves subscriber info
  onSaveInfo() {
    this.selectProduct(this.data.products[0]);
  }

  // Select Payment Method
  selectPaymentMethod(method) {
    this.selectedPaymentMethod = this.paymentMethods.find(obj => obj.id == method.value);
  }

  // Confirm payment and open 3rd party payment system
  subscribe() {
    this.getProductId();
  }

  /** Get product id and open 3rd party payment form  */
  getProductId() {
    this.currentStep = 2;
    this.data.productsService.purchaseProduct({ productId: this.selectedProduct.id, paymentMethod: this.selectedPaymentMethod.id, assetId: this.data.assetId }).then((resp: any) => {
      this.paymentUrl = resp.paymentUrl;
      this.orderId = resp.orderId;
      this.checkPayment(resp.orderId);
    });
  }

  // Cancel Payment in last polling step
  cancelPayment() {
    this.closeDialog();
    clearInterval(this.polling);
  }

  // Close Dialog and sent true or false based on if the payment is success
  closeDialog() {
    this.dialogRef.close(this.currentStep == 3 ? true : false);
  }

  // Open Payment Window Again
  openWindowAgain() {
    window.open(this.paymentUrl, "_blanck", "width=500,height=500");
  }

  // Polling mechanism to check the payment status
  checkPayment(orderId) {
    let self = this;
    clearInterval(this.polling);
    this.polling = setInterval(function () {
      self.data.productsService.checkPayment({ orderCode: orderId }).then((resp: any) => {
        if (resp.data.status == 1) {
          clearInterval(self.polling);
          self.currentStep = 3;
        } else if (resp.data.status == 2) {
          clearInterval(self.polling);
          self.currentStep = 4;
        }
      });
    }, 15000);
  }
}